## Terms

-app-name = Online-Portal

## Reauthenticate

global-reauthenticate-dialog-heading = Sitzung abgelaufen
global-reauthenticate-dialog-message = Deine Sitzung ist abgelaufen. Du musst dich erneut anmelden, bevor du mit der Beratung fortfahren kannst.
global-reauthenticate-dialog-confirm = Zur Anmeldung

## Reload

global-reload-dialog-heading = Aktualisierung verfügbar
global-reload-dialog-message =
  <p>{-app-name} wurde aktualisiert. Die Plattform muss neu geladen werden, bevor du mit der Beratung fortfahren kannst.</p>
  <p>Solltest du ungespeicherte Änderungen haben, können diese leider nicht wiederhergestellt werden.</p>
global-reload-dialog-confirm = Neu laden
